import React, { useState, useEffect } from 'react';
import '../../../scss/components/pages/staffList.scss';
import swal from 'sweetalert2';
import Pagination from '../../Pagination';
import EditLeaveType from '../../EditLeaveType';
import API from '../../../middleware/API';
import { lowerFirst } from 'lodash';

const LeaveTypeList = () => {
 const [leaveTypeList, setLeaveTypeList] = useState ([]);
 const [isEditShow, setIsEditShow] = useState (false);
 const [editType, setEditType] = useState ('ADD');
 const [reload, doRepoad] = useState (false);
 const [editInformation, setEditInformation] = useState ({});

 useEffect(
  ()=>{
    API.get('Leave').then((res) => {
      if (res) {
        setLeaveTypeList(res)
      }
    });    
  }
 ,[reload]);

 useEffect(
  ()=>{
       
  }
 ,[editInformation]);
 const handleSaveLeaveType = () => {
   
   if(editType === 'ADD'){

    var isVaild = true;
    var alertText = '';

    editInformation.enable = 0;
    if(isNaN(editInformation.approveDay)){
      alertText = '簽核時限請填數字\n';
      isVaild = false;
    }else{
      editInformation.approveDay = parseInt(editInformation.approveDay);
    }
    if(isNaN(editInformation.beforeDay)){
      alertText = alertText + '規定提前請假天數請填數字\n';
      isVaild = false;
    }else{
      editInformation.beforeDay = parseInt(editInformation.beforeDay);
    }
    if(isNaN(editInformation.deLeaveAmt)){
      alertText = alertText + '全勤扣款金額請填數字\n';
      isVaild = false;
    }else{
      editInformation.deLeaveAmt = parseInt(editInformation.deLeaveAmt);
    }

    if(isNaN(editInformation.minHours)){
      alertText = alertText + '請假最小單位請填數字\n';
      isVaild = false;
    }else{
      editInformation.minHours = parseInt(editInformation.minHours);
    }
    if(isNaN(editInformation.wageTimes)){
      alertText = alertText + '扣幾日薪請填數字\n';
      isVaild = false;
    }else{
      editInformation.wageTimes = parseFloat(editInformation.wageTimes);
    }
    if (alertText.length > 0){
      alert(alertText)
    }

    if(isVaild){
      API.post('Leave', editInformation).then((res) => {
        if (res) {
          doRepoad(!reload)
          toggleEditBlockShow();

        }
      });
    }
 
   }else{
    editInformation.approveDay = parseInt(editInformation.approveDay);
    editInformation.beforeDay = parseInt(editInformation.beforeDay);
    editInformation.deLeaveAmt = parseInt(editInformation.deLeaveAmt);
    editInformation.leavesDay = parseInt(editInformation.leavesDay);
    editInformation.minHours = parseInt(editInformation.minHours);
    editInformation.wageTimes = parseFloat(editInformation.wageTimes);

    console.log(editInformation);
    
    API.put('Leave/'+ editInformation.id, editInformation).then((res) => {
      if (res) {
        doRepoad(!reload)
        toggleEditBlockShow();

      }
    });  
   }
   
 };
 const toggleLeaveStatus = (id) => {
  API.patch('Leave/'+ id).then((res) => {
    if (res) {
      doRepoad(!reload)
    }
  });  
 }


 const toggleEditBlockShow = () => {
    setIsEditShow(!isEditShow);
 };
 const setEditTarget = (id) => {
  setEditType('EDIT')

    setEditInformation(leaveTypeList.find(leave=>leave.id === id));
    toggleEditBlockShow();
 };

 const createNewLeaveType = () => {
   setEditType('ADD')
  setEditInformation({
  });
  toggleEditBlockShow();
};
 const handleOnChangeInput = (key, e) => {
      setEditInformation({
        ...editInformation, 
        [key] : e.target.value
      })
  }
 return(
  <div className="p-staff-list">
    <div className="u-block">
      <div className="u-title">假別列表</div>
      <div className="u-btn-group p-0" style={{justifyContent: 'space-between'}}>
        <button className="btn btn-md save" onClick={createNewLeaveType}>新增假別</button>
      </div>
      <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped">
          <thead>
            <tr>
                <th>假別名稱</th>
                <th>規定提前請假天數</th>
                <th>請假最小單位(小時)</th>
                <th>扣幾日薪</th>
                <th>給假天數</th>
                <th>全勤扣款金額</th>
                <th>簽核時限(天)</th>
                <th>備註</th>
                <th>狀態</th>
                <th></th>
            </tr>
          </thead>
          <tbody>
            {
              leaveTypeList.map(leaveType => (
                <tr key={leaveType.id}>
                  <td>{leaveType.name}</td>
                  <td>{leaveType.beforeDay}</td>
                  <td>{leaveType.minHours}</td>
                  <td>{leaveType.wageTimes}</td>
                  <td>{leaveType.leavesDay}</td>
                  <td>{leaveType.deLeaveAmt}</td>
                  <td>{leaveType.approveDay}</td>
                  <td> <textarea name="notes" id="notes" cols="30" rows="5" disabled style={{resize:'none'}} value={leaveType.notes||''}></textarea> </td>
                  <td>
                    <div className="u-check-box">
                      <input id={`chk_${leaveType.id}`} type="checkbox" checked={leaveType.enable ? true : false}
                        onChange={()=>{
                          toggleLeaveStatus(leaveType.id);
                        }}/>
                      <label htmlFor={`chk_${leaveType.id}`}></label>
                    </div>
                  </td>
                  <td><button onClick={()=>{setEditTarget(leaveType.id)}}>編輯</button></td>
                </tr>)
              )
            }
          </tbody>
        </table>
      </div>
      <EditLeaveType
        editType={editType}
        isShow={isEditShow}
        editInformation={editInformation}
        onChangeFunc={handleOnChangeInput}
        saveFunc={handleSaveLeaveType}
        toggleFunc={toggleEditBlockShow}
      />
    </div>
  </div>
 );
}

export default LeaveTypeList

